module.exports = __webpack_public_path__ + "static/media/10.Full Range Of Spare Parts.a76ffb42.jpg";